/* eslint-disable import/no-anonymous-default-export */
// const baseUrl = "http://192.168.18.18:8000/";
const baseUrl = "https://carsapi.saldr.tech/";

export default {
  // Shared API host for client, dealers, and inspection.
  baseUrl,
  // Inspection still reads `baseUrl` from this object.
  baseUrl: baseUrl,
  googleClientId:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "647784950474-6o32gkrkbdf5v2d51876tph7or1gfl4k.apps.googleusercontent.com",
};
